import { useState } from "react";
import { anularFactura } from "../services/facturaService";

export const useAnularFactura = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const execute = async (idFactura, username) => {
    try {
      setLoading(true);
      setError(null);

      const data = await anularFactura(idFactura, username);

      return data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    execute,
    loading,
    error,
  };
};
